var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-logo"},[_c('img',{attrs:{"src":require("@/assets/img/logo.png"),"alt":"","width":"26"}}),_vm._v("    "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapse),expression:"!collapse"}]},[_vm._v("华燕拆车")])])
}
var staticRenderFns = []

export { render, staticRenderFns }